import React from 'react';
import { Award, CheckCircle } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { mockAccreditations } from '../mock';

const Accreditations = () => {
  return (
    <section id="accreditations" className="py-24 bg-gray-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center p-3 bg-emerald-500/20 rounded-full mb-4">
            <Award className="text-emerald-400" size={32} />
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Accreditations & <span className="text-emerald-400">Certifications</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            We provide all documentation bespoke to your business profile and size
          </p>
        </div>

        {/* Accreditations Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {mockAccreditations.map((accreditation, index) => (
            <Card
              key={index}
              className="bg-gray-800/50 backdrop-blur-sm border-gray-700 hover:bg-gray-800 hover:border-emerald-500 transition-all duration-300 hover:-translate-y-1"
            >
              <CardContent className="p-6">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <CheckCircle className="text-emerald-400" size={24} />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">
                      {accreditation.name}
                    </h3>
                    <p className="text-gray-400">{accreditation.description}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Additional Info */}
        <div className="bg-emerald-500/10 border border-emerald-500/20 rounded-2xl p-8 backdrop-blur-sm">
          <h3 className="text-2xl font-bold text-white mb-4 text-center">
            Additional Services
          </h3>
          <div className="grid md:grid-cols-2 gap-6 text-gray-300">
            <div className="space-y-2">
              <h4 className="font-semibold text-emerald-400 text-lg">HR Services</h4>
              <p>Outsourced HR solutions tailored to your business complexity</p>
            </div>
            <div className="space-y-2">
              <h4 className="font-semibold text-emerald-400 text-lg">Office Services</h4>
              <p>Email monitoring, invoicing, purchase invoicing, and bookkeeping</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Accreditations;
